module.exports = __webpack_public_path__ + "img/barcelo-activities.4bb25c4b.jpg";